import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

import { useRoles } from '../data/store/useRoles';
import { useProfile } from '../data/store/useProfile';

/**
 * Snapshot of who is running a query, used by the song services to pick a
 * query shape the Firestore rules can prove readable. Firestore evaluates
 * list queries against every document that COULD match, so a feed query must
 * carry filters (privacy tier, groupId) that make `canReadSong()` provably
 * true for the whole result set — otherwise the query is denied wholesale.
 *
 * Staff pass `canReadSong()` for any document (the isStaff() branch doesn't
 * depend on resource data), so staff queries may skip privacy filters.
 */
export interface Viewer {
  uid?: string;
  authed: boolean;
  staff: boolean;
}

export const getViewer = (): Viewer => {
  const user = firebase.auth().currentUser;
  const authority: string[] = (useRoles.getState().role as any)?.authority || [];
  const staff =
    authority.includes('admin') ||
    authority.includes('super admin') ||
    authority.includes('moderator');
  return { uid: user?.uid || undefined, authed: !!user, staff };
};

/**
 * Audience tier a playlist/album inherits from its creator's profile: only an
 * explicitly public profile shares publicly; anything else is members-only.
 * Mirrors functions/src/collectionPrivacy.ts tierFor().
 */
export const viewerCollectionTier = (): 'public' | 'member' =>
  useProfile.getState().privacy === 'public' ? 'public' : 'member';
